module.exports = __webpack_public_path__ + "img/9-03.f5ed28c3.png";